module.exports = __webpack_public_path__ + "img/n_img2.2b4fa30f.png";